import React, {useState} from 'react';
import { Collapse, Checkbox, List, ListItem, ListItemText, ListItemIcon,useMediaQuery } from '@mui/material';
import {ExpandLess, ExpandMore, ModelTraining, Public } from '@mui/icons-material';
import styled from 'styled-components';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';

import './CheckboxFacet.css';

export default function CheckboxFacet(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    let [isExpanded, setIsExpanded] = useState(true);
    const filteredCheckboxes = props.values
    .filter(facetValue => facetValue.value !== "")
    .sort((a, b) => a.value.localeCompare(b.value));
  

    const checkboxes = filteredCheckboxes.map(facetValue => {

        let isSelected = props.selectedFacets.some(facet => facet.value === facetValue.value);
        
        return (
            <FacetValueListItem dense disableGutters id={facetValue.value}>
                <ListItemText primary={facetValue.value + " (" + facetValue.count + ")"}/>
                <Checkbox 
                    edge="start" 
                    disableRipple 
                    checked={isSelected}
                    onClick= {
                        isSelected ? 
                        () => props.removeFilter({field: props.name, value: facetValue.value}) :
                        () => props.addFilter(props.name, facetValue.value)
                    }
                    sx = {{'&.Mui-checked': {
      color: '#14143C', // color when checked
    },}}
                />
                
            </FacetValueListItem>
        );
    });


    return (
        <div>
            <FacetListItem disableRipple={true} button onClick={() => setIsExpanded(!isExpanded)}>
            <ListItemIcon>
            {props.name === 'category' ? <ModelTraining style={{ color: '#7b8193', width:isMobile? '25px':'30px',paddingRight:'5px'}}/> :
                props.name === 'source' ? <Public style={{ color: '#7b8193', width:isMobile? '25px':'30px',paddingRight:'5px'}}/> : null}
            </ListItemIcon>
                <ListItemText 
                    primary={props.mapFacetName(props.name)}
                />
                {isExpanded ? <ExpandLess /> : <ExpandMore />}
            </FacetListItem>
            <Divider sx={{ borderBottom: '1px solid #14143c', marginTop: '10px', marginLeft:'35px',marginRight:'20px', width:'85%'}}/>
            <Collapse in={isExpanded} component="div">
                <FacetValuesList>
                    {checkboxes.length === 0 ? (
  <p style={{ textAlign: 'center', padding: '1rem', color: '#808080', fontSize:'16px' }}>
    No filters are available for the selected source.
  </p>
) : (
  checkboxes
)}

                      
                </FacetValuesList>
            </Collapse>
        </div>
    );
}

const FacetListItem = styled(ListItem)({
    paddingLeft: '36px !important',
})

const FacetValueListItem= styled(ListItem)({
    paddingLeft: '46px !important',
});

const FacetValuesList= styled(List)({
    marginRight: '0px !important'
})